// This file contains the list of restricted countries that shouldn't pull all the data for the store locator.
// For business reasons, for US and CA store locator only will show stores for those countries specifically. Otherwise, it will show all the stores.

export const EUCountries = [
    "CZ",
    "DK",
    "FI",
    "EE",
    "HU",
    "FR",
    "DE",
    "SE",
    "NL",
    "LT",
    "LV",
    "CH",
    "PL",
    "BE",
    "AT",
    "NO",
    "SK",
    "IE",
    "SI",
    "HR",
    "PT",
    "ES",
];

export const restrictedCountries = ["US", "CA", "SG", "AU", "JP", "MY", "KR", "IN", ...EUCountries];
